import { createContext } from 'react';

const songContext = createContext();

export default songContext;
